import { memo } from 'react'

import ExpandableSection from '../../ExpandableSection'
import AttributesSettings from './AttributesSettings'
import BlocksVisibility from './BlocksVisibility'
import DestinationsSettings from './DestinationsSettings'
import EmailsSettings from './EmailsSettings'
import HeaderSettings from './HeaderSettings'
import MetaSettings from './MetaSettings'
import OtherSettings from './OtherSettings'
import PricesSettings from './PricesSettings'
import ReadyCloudSettings from './ReadyCloudSettings'
import SuccessSettings from './SuccessSettings'
import TrackingPageSettings from './TrackingPageSettings'

interface Props {
  isCreateMode?: boolean
  partnerCode?: string
}

function PartnerFormInner({ isCreateMode, partnerCode }: Props) {
  return (
    <>
      <ExpandableSection title="Headers and labels">
        <HeaderSettings isInitialCodeExist={Boolean(partnerCode)} />
      </ExpandableSection>
      <ExpandableSection title="Success page text">
        <SuccessSettings />
      </ExpandableSection>
      <ExpandableSection title="Meta data">
        <MetaSettings />
      </ExpandableSection>
      <ExpandableSection title="Displayed parts">
        <BlocksVisibility />
      </ExpandableSection>
      <ExpandableSection title="Emails">
        <EmailsSettings />
      </ExpandableSection>
      <ExpandableSection title="Other">
        <OtherSettings isCreateMode={isCreateMode} />
      </ExpandableSection>
      <ExpandableSection title="Tracking Page Configuration">
        <TrackingPageSettings />
      </ExpandableSection>
      <ExpandableSection title="ReadyCloud  odule">
        <ReadyCloudSettings />
      </ExpandableSection>
      <ExpandableSection title="Attributes">
        <AttributesSettings />
      </ExpandableSection>
      <ExpandableSection title="Prices">
        <PricesSettings />
      </ExpandableSection>
      <ExpandableSection title="Partner Destinations">
        <DestinationsSettings partnerCode={partnerCode} />
      </ExpandableSection>
    </>
  )
}

export default memo(PartnerFormInner)
